import isURL from 'validator/es/lib/isURL';

export const triPosDefaults = {
  AcceptorId: '',
  AccountId: '',
  AccountToken: '',
  LaneId: '',
  Port: '',
  TriPosCloud: false,
  TriPosCloudUrl: 'https://triposcert.worldpay.com',
  TriPosDirectPort: '',
  TriPosDirectUrl: 'https://triposcert.worldpay.com',
  IsGiftSupported: false,
  AllowDebit: false,
  AllowPartialApprovals: false,
  CheckForDuplicateTransactions: true,
  CurrencyCode: '',
  MarketCode: '',
  BillingAddress1: '',
  BillingAddress2: '',
  BillingCity: '',
  BillingPostalCode: '',
  BillingState: '',
};

export const triPosFields = {
  mandatory: {
    AcceptorId: {
      id: 'AcceptorId',
      title: 'Acceptor ID',
      type: 'text',
      validate: (val) => (val?.toString().length ? null : 'Field is required.'),
    },
    AccountId: {
      id: 'AccountId',
      title: 'Account ID',
      type: 'text',
      validate: (val) => (val?.toString().length ? null : 'Field is required.'),
    },
    AccountToken: {
      id: 'AccountToken',
      title: 'Account Token',
      type: 'text',
      validate: (val) => (val?.length ? null : 'Field is required.'),
    },
  },
  additional: {
    CurrencyCode: {
      id: 'CurrencyCode',
      title: 'Currency Code',
      type: 'text',
      // validate: val => (val?.length ? null : 'Field is required.'),
    },
    BillingAddress1: {
      id: 'BillingAddress1',
      title: 'Billing Address 1',
      type: 'text',
      // validate: val => (val?.length ? null : 'Field is required.'),
    },
    BillingAddress2: {
      id: 'BillingAddress2',
      title: 'Billing Address 2',
      type: 'text',
      // validate: val => (val?.length ? null : 'Field is required.'),
    },
    BillingCity: {
      id: 'BillingCity',
      title: 'Billing City',
      type: 'text',
      // validate: val => (val?.length ? null : 'Field is required.'),
    },
    BillingPostalCode: {
      id: 'BillingPostalCode',
      title: 'Billing Postal Code',
      type: 'text',
      // validate: val => (val?.length ? null : 'Field is required.'),
    },
    BillingState: {
      id: 'BillingState',
      title: 'Billing State',
      type: 'text',
      // validate: val => (val?.length ? null : 'Field is required.'),
    },
    IsGiftSupported: {
      id: 'IsGiftSupported',
      title: 'Is Gift Supported',
      type: 'checkbox',
      // validate: val => (val?.length ? null : 'Field is required.'),
    },
    MarketCode: {
      id: 'MarketCode',
      title: 'Market Code',
      type: 'text',
      // validate: val => (val?.length ? null : 'Field is required.'),
    },
    AllowDebit: {
      id: 'AllowDebit',
      title: 'Allow Debit',
      type: 'checkbox',
      // validate: val => (val?.length ? null : 'Field is required.'),
    },
    AllowPartialApprovals: {
      id: 'AllowPartialApprovals',
      title: 'Allow Partial Approvals',
      type: 'checkbox',
      // validate: val => (val?.length ? null : 'Field is required.'),
    },
    CheckForDuplicateTransactions: {
      id: 'CheckForDuplicateTransactions',
      title: 'Check For Duplicate Transactions',
      type: 'checkbox',
      // validate: val => (val?.length ? null : 'Field is required.'),
    },
  },
  direct: {
    TriPosDirectUrl: {
      id: 'TriPosDirectUrl',
      title: 'TriPos Direct Url',
      type: 'text',
      validate: (val) => {
        if (val?.length) {
          return isURL(val) ? null : 'Invalid url.';
        }
        return 'TriPos Direct Url is required.';
      },
    },
    LaneId: {
      id: 'LaneId',
      title: 'Lane ID',
      type: 'select',
      validate: (val) =>
        val?.toString().length ? null : 'Direct Lane ID is required.',
    },
  },
  cloud: {
    TriPosCloudUrl: {
      id: 'TriPosCloudUrl',
      title: 'TriPos Cloud Url',
      type: 'select',
      validate: (val) => {
        if (val?.length) {
          return isURL(val) ? null : 'Invalid url.';
        }
        return 'TriPos Cloud Url is required.';
      },
    },
    LaneId: {
      id: 'LaneId',
      title: 'Lane ID',
      type: 'select',
      /* validate: val =>
          val?.toString().length ? null : 'Cloud Lane ID is required.', */
    },
  },
};
